module.exports = "/images/vendor/vue-paycard/src/10.jpg?620fe682cf1758043edbced62982910f";